import { useTrackScrollTop } from "../../lib/hooks/TrackScrollTop.hook";
import MessagingConversations from "./MessagingBody/MessagingConversations";
import MessagingConversationsScrollToTopButton from "./MessagingBody/MessagingConversationsScrollToTopButton";
import MessagingHeaderNetworkStatus from "./MessagingHeader/MessagingHeaderNetworkStatus";
import MessagingSearch from "./MessagingHeader/MessagingSearch";

export type MessagingConversationsColumnProps = {
}

export default function MessagingConversationsColumn({ }: MessagingConversationsColumnProps) {
    const { ref: scrollDivRef, scrollTop, scrollTo } = useTrackScrollTop();

    return (
        <div className="flex flex-col w-full h-full">
            <div className="basis-[70px]">
                <MessagingSearch />
            </div>
            <div className="flex-grow relative border-t border-gray-300">
                <div ref={scrollDivRef} className="absolute left-0 top-0 w-full h-full overflow-y-auto">
                    <MessagingConversations />
                </div>
                <MessagingConversationsScrollToTopButton scrollTop={scrollTop} onClick={() => {
                    scrollTo({ top: 0, behavior: "smooth" });
                }} />
                <MessagingHeaderNetworkStatus />
            </div>
        </div>
    );
}